import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProfileProvider } from "@/context/ProfileContext";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { preloadBankDirectory } from "@/lib/nbu";

// Pages
import { Home } from "@/pages/Home";
import { Dashboard } from "@/pages/Dashboard";
import { Applications } from "@/pages/Applications";
import { ApplicationWizard } from "@/pages/ApplicationWizard";
import { ApplicationView } from "@/pages/ApplicationView";
import { ReportWizard } from "@/pages/ReportWizard";
import { Help } from "@/pages/Help";
import { Settings } from "@/pages/Settings";
import { AuthCallback } from "@/pages/AuthCallback";
import { AuthError } from "@/pages/AuthError";

// Feature flag for new application
const isNewApplicationEnabled = import.meta.env.VITE_FEATURE_NEW_APPLICATION === "true";

// Preload NBU bank directory in background for faster IBAN validation
preloadBankDirectory();

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ProfileProvider>
          <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/auth-results" element={<AuthCallback />} />
          <Route path="/auth-results/" element={<AuthCallback />} />
          <Route path="/auth-error" element={<AuthError />} />
          <Route path="/auth-error/" element={<AuthError />} />

          {/* Protected routes - require authentication */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* Applications */}
          <Route
            path="/applications"
            element={
              <ProtectedRoute>
                <Applications />
              </ProtectedRoute>
            }
          />
          <Route
            path="/application/new"
            element={
              isNewApplicationEnabled ? (
                <ProtectedRoute>
                  <ApplicationWizard />
                </ProtectedRoute>
              ) : (
                <Navigate to="/dashboard" replace />
              )
            }
          />
          <Route
            path="/application/:id"
            element={
              <ProtectedRoute>
                <ApplicationWizard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/application/:id/edit"
            element={
              <ProtectedRoute>
                <ApplicationWizard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/application/:id/view"
            element={
              <ProtectedRoute>
                <ApplicationView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/application/:id/report"
            element={
              <ProtectedRoute>
                <ReportWizard />
              </ProtectedRoute>
            }
          />

          {/* Help & Settings */}
          <Route
            path="/help"
            element={
              <ProtectedRoute>
                <Help />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />

          {/* Fallback - redirect to home */}
          <Route path="*" element={<Home />} />
          </Routes>
        </ProfileProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
